// src/newDashboard/layout/OwnerLayout.jsx
//
// The owner dashboard is grouped into 5 sections. Each section can have
// sub-tabs (the existing pages), shown as buttons at the top of the page.
// The frame itself (side menu on a computer, bottom bar on a phone) is
// DashboardShell.jsx.

import React from "react";
import { useActiveBar } from "../ActiveBarContext";
import DashboardShell from "./DashboardShell";

const ADVERTISE_URL = "https://barfunfinder.com/advertise.html";

const SECTIONS = [
  {
    label: "Today",
    short: "Today",
    to: "/owner",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5L19 19M5 19l1.5-1.5M17.5 6.5L19 5" />
      </svg>
    ),
    tabs: [],
  },
  {
    label: "Schedule",
    short: "Schedule",
    to: "/owner/create-event",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <rect x="3" y="5" width="18" height="16" rx="2" />
        <path d="M3 10h18M8 3v4M16 3v4" />
      </svg>
    ),
    tabs: [
      { label: "Events", to: "/owner/create-event" },
      { label: "Specials", to: "/owner/specials" },
      { label: "Today's food photo", to: "/owner/todays-special" },
    ],
  },
  {
    label: "My Bar",
    short: "My Bar",
    to: "/owner/bar-profile",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <path d="M3 21V10l9-6 9 6v11" />
        <path d="M9 21v-6h6v6" />
      </svg>
    ),
    tabs: [
      { label: "Profile & photos", to: "/owner/bar-profile" },
      { label: "Jobs", to: "/owner/jobs" },
      { label: "Charity gaming", to: "/owner/gaming-inventory" },
      { label: "Linked charities", to: "/owner/linked-venues" },
      { label: "Claim another bar", to: "/owner/claim-bar" },
    ],
  },
  {
    label: "Promote",
    short: "Promote",
    to: "/owner/subscription",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <path d="M3 11l14-6v14L3 13z" />
        <path d="M7 13v5h3" />
      </svg>
    ),
    tabs: [
      { label: "Get featured", to: "/owner/subscription" },
      { label: "Offers", to: "/owner/offers" },
      { label: "Send an update", to: "/owner/post-update" },
      { label: "Advertise", href: ADVERTISE_URL },
    ],
  },
  {
    label: "Account & Help",
    short: "More",
    to: "/owner/account",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21a8 8 0 0 1 16 0" />
      </svg>
    ),
    tabs: [
      { label: "Account", to: "/owner/account" },
      { label: "Help", to: "/owner/help" },
    ],
  },
];

export default function OwnerLayout({ children }) {
  const { myBars, activeBarId, setActiveBarId } = useActiveBar();

  const barPicker =
    myBars.length > 0 ? (
      <div className="os-bar">
        <label htmlFor="os-bar" className="os-bar-label">Your bar</label>
        <select
          id="os-bar"
          className="os-bar-select"
          value={activeBarId}
          onChange={(e) => setActiveBarId(e.target.value)}
        >
          {myBars.map((bar) => (
            <option key={bar.id} value={bar.id}>{bar.name || "Unnamed Bar"}</option>
          ))}
        </select>
      </div>
    ) : null;

  return (
    <DashboardShell sections={SECTIONS} barPicker={barPicker}>
      {children}
    </DashboardShell>
  );
}
